import {
  animate,
  AnimationMetadata,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { KeyValue } from '@angular/common';
import { Component, TemplateRef, TrackByFunction } from '@angular/core';
import { async } from '../rx/util';
import { ModalContext } from './modal.directive';
import { ModalKey, ModalService } from './modal.service';

const modalSlideEnter: AnimationMetadata | AnimationMetadata[] = [
  style({ transform: 'translateY(25px)' }),
  animate('100ms ease-in'),
];

const modalSlideLeave: AnimationMetadata | AnimationMetadata[] = animate(
  '100ms ease-out',
  style({ transform: 'translateY(25px)' }),
);

export const modalTransitions = [
  transition(':enter', [
    style({
      opacity: '0',
    }),
    group([
      animate('100ms ease-in'),
      query('compact-modal > .content, modal > .content', modalSlideEnter, {
        optional: true,
      }),
    ]),
  ]),
  transition(':leave', [
    group([
      animate('100ms ease-out', style({ opacity: 0 })),
      query('compact-modal > .content, modal > .content', modalSlideLeave, {
        optional: true,
      }),
    ]),
  ]),
];

@Component({
  animations: [trigger('fade', modalTransitions)],
  selector: 'modal-outlet',
  styleUrls: ['./modal-outlet.component.scss'],
  templateUrl: './modal-outlet.component.html',
})
export class ModalOutletComponent {
  readonly modals = this.modalService.change.pipe(async());

  constructor(private readonly modalService: ModalService) {}

  readonly trackModal: TrackByFunction<
    KeyValue<ModalKey, TemplateRef<ModalContext>>
  > = (_, { key }: { key: ModalKey }) => key;
}
